export const
    ROAD_BOOK_CONFIGURATIONS_PENDING = 'road_book_configurations_pending',
    ROAD_BOOK_CONFIGURATION_SENDING = 'road_book_configuration_sending',
    ROAD_BOOK_CONFIGURATIONS_DOWNLOADED = 'road_book_configurations_downloaded',
    ROAD_BOOK_CONFIGURATION_DOWNLOADED = 'road_book_configuration_downloaded',
    ROAD_BOOK_CONFIGURATIONS_FAILED = 'road_book_configurations_failed',
    ROAD_BOOK_CONFIGURATION_FOCUS = 'road_book_configuration_focus',
    ROAD_BOOK_CONFIGURATION_DELETING = 'road_book_configuration_deleting',
    ROAD_BOOK_CONFIGURATION_DELETED = 'road_book_configuration_deleted';



// WEBPACK FOOTER //
// src/store/roadBookConfigurations/types.js